import { CompareHelper } from '@barthauer/abc/core';
import { AbcCameraDetailsService } from '@barthauer/abc/ui-components';
import { ValueWrapperViewModel } from '../../../helpers/valueWrapper';
import { ArenaService } from '../../arena.service';
import { DataFormService } from '../data-form.service';
import { DataFormSettings } from './settings.model';
import { UiComponentCreator } from './ui-component-creator';

export class Creator {
  private uiComponentCreator: UiComponentCreator;
  constructor(
    private service: DataFormService,
    private settings: DataFormSettings,
    private abcCameraDetailsService: AbcCameraDetailsService,
    private arenaService: ArenaService,
  ) {
    this.init();
  }

  private init(): void {
    this.settings.objectKey = new ValueWrapperViewModel(this.service.persistence);
  }

  private objectFunctionsStartIndex: number;
  private objectFunctionsCount: number;
  public async create(): Promise<void> {
    if (!CompareHelper.isNullorEmpty(this.objectFunctionsStartIndex)) {
      this.settings.setCurrentObjectFunctions.splice(this.objectFunctionsStartIndex, this.objectFunctionsCount);
    }

    this.objectFunctionsStartIndex = this.settings.setCurrentObjectFunctions.length;
    this.uiComponentCreator = new UiComponentCreator(
      this.service,
      this.settings,
      this.abcCameraDetailsService,
      this.arenaService,
    );
    this.settings.mainObjectTypeViewModel = await this.service.core.objectSpace
      .getObjectType(this.service.abcArena.context.defaultObjectType ?? this.settings.layoutViewModel.objectType)
      .toPromise();

    this.ensureCleaningGallery();

    await this.uiComponentCreator.createUiComponents();
    this.objectFunctionsCount = this.settings.setCurrentObjectFunctions.length - this.objectFunctionsStartIndex;
  }

  private ensureCleaningGallery(): void {
    this.settings.abcGalleryCptRef?.componentRef?.destroy();
    this.settings.htmlGroups = [];
  }

  public updateTabsUi(identifier: string): void {
    this.uiComponentCreator.abcComponentUiCreator.update(identifier);

    // if (this.settings.abcGalleryCptRef.componentRef?.instance?.dataSource?.length === 0) {
    //   const dataFormFixedGroup = document.querySelector('#fixedGroup') as HTMLElement;
    //   const tabs = document.querySelector('#tabs') as HTMLElement;
    //   if (!this.service.arena.uiconfig.renderHigna) {
    //     tabs.style.setProperty('height', '80%', 'important');
    //   } else {
    //     dataFormFixedGroup.style.setProperty('max-height', 200 + 'px', 'important');
    //     const heightY = dataFormFixedGroup.getBoundingClientRect().height;
    //     const divider = document.querySelector('.divider') as HTMLElement;
    //     const newTop = divider?.offsetTop;
    //     tabs.style.setProperty('height', newTop - heightY - 52 + 'px', 'important');
    //     tabs.style.boxShadow = 'inset 0px 0px 4px 0px var(--PrimaryMainShading90)';
    //     tabs.style.padding = '5px';
    //     tabs.style.backgroundColor = '';
    //   }
    //   tabs.style.setProperty('height', 0 + 'px', 'important');
    //   //dataFormFixedGroup.style.setProperty('height', this.newTop - 79 + 'px', 'important');
    //   dataFormFixedGroup.style.removeProperty('max-height');
    //   dataFormFixedGroup.style.removeProperty('overflow');
    //   tabs.style.boxShadow = 'none';
    //   tabs.style.backgroundColor = 'var(--PrimaryBackgroundColor)';
    // }
  }
}
